import { Footer2022, Intro2022 } from './components';
import { use2022Page } from './shared';

const Highlights2022 = () => {
  use2022Page({ cate: 'highlights', lang: 'en', title: 'Smart Living Partnership Awards 2022 - Highlights' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="en" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/judgebg-01.png" alt="" /></div></section>
      <section id="Highlights"><div className="Highlights_info"><div className="Highlights_Title">HIGHLIGHTS</div><div className="Highlights_TitleLine"><div className="Highlights_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div><div className="Highlights_Table"><div className="Highlights_Photos"><p>Photos</p></div><div className="Highlights_Videos"><a href="/2022/highlightsVideo.php"><p>Videos</p></a></div><div className="Highlights_Articles"><a href="https://www.etnet.com.hk/www/tc/news/topic_news_category.php?category=smartlivingawards" target="_blank" rel="noreferrer"><p>Articles</p></a></div></div><div className="Highlights_Photo_Table">{Array.from({ length: 10 }).map((_, i) => (<div className="Highlights_Photo_Table_Photo" key={i}><img src={`/2022/images/Highlight${i + 1}.jpg`} alt="" /></div>))}</div></div></section>
      <Footer2022 lang="en" />
    </div>
  );
};

export default Highlights2022;

